<template>
  <div class="im-right">
    <im-right-list />
    <im-right-content />
  </div>
</template>

<script>
import ImRightList from './ImRightList'
import ImRightContent from './ImRightContent'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'ImRight',
  components: {
    ImRightList,
    ImRightContent
  },
  data () {
    return {
      notificationInstances: []
    }
  },
  computed: {
    ...mapState({
      imConnectionId: state => state.imConnectionId,
      imActiveAccount: state => state.imActiveAccount,
      imVisible: state => state.imVisible,
      imAccount: state => state.imAccount,
      imLeftActiveName: state => state.imLeftActiveName,
      imShowChatInfoVisible: state => state.imShowChatInfoVisible,
      imUserProfiles: state => state.imUserProfiles,
      imQyhContactData: state => state.imQyhContactData
    })
  },
  watch: {
    imVisible (val) {
      if (val && this.imActiveAccount.id && this.imActiveAccount.id !== '7380252502656237619') {
        const session = this.$store.state.imSessionMap[this.imActiveAccount.id]
        // if (session.unread > 0) this.$store.dispatch('reduceImUnreadCountAction', session.unread)
        this.imActiveChange({ session: session, scene: this.imActiveAccount.scene, to: this.imActiveAccount.to, messageListScrollTot: 'bottom', imAccId: this.imAccount.im_accid })
      } else if (!val && this.imActiveAccount.id && this.imActiveAccount.id !== '7380252502656237619') {
        this.resetCurrSession(this.imActiveAccount)
      }
    },
    imActiveAccount (newValue) {
      if (this.imShowChatInfoVisible) this.$store.dispatch('changeImShowChatInfoVisibleAction', false)
      // if (newValue.to !== '7380252502656237619') {
      //   this.$store.commit('setBotFollowUpMutation', [])
      //   this.$store.commit('setBotChunkIngMutation', false)
      // }
    }
  },
  methods: {
    ...mapActions(['addMsgToMsgArr', 'markMsgReceived', 'msgReceiptSend', 'imActiveChange', 'resetCurrSession', 'imNotifyErrorVisibleAction', 'imNotifyMsgAction', 'sendCustomSysMsg', 'handleLeaveTeam']),
    getImAccount () {
      this.$axios.get('/api/admin/im/account', { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 200) {
            this.$store.dispatch('changeImAccountStoreAction', data.data)
            this.imAppInit()
          }
        })
    },
    imAppInit () {
      this.$store.dispatch('initializeNim', {
        onconnect: this.onconnect,
        onwillreconnect: this.onWillReconnect,
        ondisconnect: this.ondisconnect,
        onerror: this.onError,
        onfriends: this.onfriends,
        onusers: this.onusers,
        onupdateuser: this.onupdateuser,
        onsyncfriendaction: this.onsyncfriendaction,
        onsessions: this.onsessions,
        onupdatesessions: this.onupdatesessions,
        onofflinemsgs: this.onofflinemsgs,
        onroamingmsgs: this.onroamingmsgs,
        onmsg: this.onMsg,
        onMsgReceipts: this.onMsgReceipts,
        onupdatemyinfo: this.onupdatemyinfo,
        // 群
        onteams: this.onteams,
        onCreateTeam: this.onCreateTeam,
        shouldCountNotifyUnread: this.shouldCountNotifyUnread,
        onRemoveTeamMembers: this.onRemoveTeamMembers,
        // 系统通知
        onsysmsgunread: this.onsysmsgunread,
        onupdatesysmsgunread: this.onupdatesysmsgunread,
        oncustomsysmsg: this.oncustomsysmsg,
        // 同步完成
        onsyncdone: this.onsyncdone
      })
    },
    onconnect (data) {
      console.log('连接成功', data)
      this.$store.dispatch('imConnectionIdAction', data.connectionId)
    },
    onWillReconnect (obj) {
      console.log('即将重连')
      console.log(obj.retryCount)
      console.log(obj.duration)
    },
    ondisconnect (error) {
      // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
      console.log('丢失连接')
      console.log(error)
      this.imNotifyErrorVisibleAction(true)
      this.imNotifyMsgAction(error.message)
    },
    onError (error) {
      console.log('连接错误')
      console.log(error)
    },
    onfriends (data) {},
    onusers (users) {
      users.unshift({ account: '7380252502656237619', icon: 'https://cdn.pixabay.com/photo/2020/08/19/00/13/sea-5499649_1280.jpg', nick: 'cozeAI' })
      for (const user of users) {
        this.$store.commit('addImUserProfilesMutation', user)
      }
    },
    onupdateuser (profile) {
      console.log('profile', profile)
      console.log('imUserProfiles', this.imUserProfiles)
      console.log('imQyhContactData', this.imQyhContactData)
      if (this.imUserProfiles[profile.account]) {
        let user = this.imUserProfiles[profile.account]
        user.avatar = profile.avatar
        this.$store.commit('addImUserProfilesMutation', user)
      }
      let index = this.imQyhContactData.findIndex(account => profile.account === account.im_accid)
      console.log('index', index)
      if (index !== -1) {
        let account = this.imQyhContactData[index]
        account.im_icon = profile.avatar
        this.$store.commit('setImQyhContactDataMutation', { account, index })
        console.log('setImQyhContactDataMutation', this.imQyhContactData[index])
      }
    },
    onsyncfriendaction (options) {
      console.log('onsyncfriendaction', options)
    },
    onupdatemyinfo (profile) {
      let account = this.imAccount
      account.im_icon = profile.avatar
      this.$store.dispatch('changeImAccountStoreAction', account)
    },
    onsessions (sessionArr) {
      console.log('onsession', sessionArr)
      // 会话排序
      for (const session of sessionArr) {
        this.$store.commit('setImSessionMapMutation', session)
      }
      let orderSessions =  this.getOrderedSessions(this.$store.state.imSessionMap)
      this.$store.commit('setImOrderSessionsMutation', orderSessions)

      let unread = 0;
      // 获取用户信息。稍微间隔一些获取用户信息，减少初始化时期的页面加载压力
      for (let i = 0; i < orderSessions.length; i++) {
        setTimeout(() => {
          this.updateSessionInfo(orderSessions[i])
          // this.addUnReadCount(orderSessions[i].unread)
        }, i * 100)
        unread += orderSessions[i].unread
      }
      this.refreshUnReadCount(unread)

      console.log('sessions', this.$store.state.imSessions)
    },
    onupdatesessions (sessionArr) {
      console.log('onupdatesessions', sessionArr)
      for (const session of sessionArr) {
        if (session.scene === 'team' && session.lastMsg && session.lastMsg.type === 'notification' && session.lastMsg.attach.type === 'leaveTeam' && session.lastMsg.from === this.imAccount.im_accid) {
          this.handleLeaveTeam({ teamId: session.to, teamDismissed: true })
          continue
        }
        if (this.$store.state.imSessionMap[session.id] && this.$store.state.imSessionMap[session.id].updateTime > session.updateTime)  session.updateTime = this.$store.state.imSessionMap[session.id].updateTime
        this.$store.commit('setImSessionMapMutation', session)
      }
      let orderSessions =  this.getOrderedSessions(this.$store.state.imSessionMap)
      this.$store.commit('setImOrderSessionsMutation', orderSessions)

      let unread = 0;
      // 获取用户信息。稍微间隔一些获取用户信息，减少初始化时期的页面加载压力
      for (let i = 0; i < orderSessions.length; i++) {
        setTimeout(() => {
          this.updateSessionInfo(orderSessions[i])
          if (orderSessions[i].scene === 'p2p') this.markMsgReceived(orderSessions[i])
        }, i * 100)
        unread += orderSessions[i].unread
      }
      this.refreshUnReadCount(unread)
    },
    // addUnReadCount (num) {
    //   this.$store.dispatch('addImUnreadCountAction', num)
    // },
    refreshUnReadCount (unread) {
      this.$store.dispatch('refreshImUnreadCountAction', unread)
    },
    getOrderedSessions (unorderedSessions) {
      return Object.keys(unorderedSessions)
        .map((id) => unorderedSessions[id])
        .sort(this.sortSession)
    },
    sortSession (sessionA, sessionB) {
      if (sessionA.isTop && !sessionB.isTop) {
        return -1
      } else if (!sessionA.isTop && sessionB.isTop) {
        return 1
      } else {
        return sessionB.updateTime - sessionA.updateTime
      }
    },
    updateSessionInfo (session) {
      if (session.scene === "p2p") {
        if (!this.$store.state.imUserProfiles[session.to]) {
          this.fetchUserInfo(session.to)
        }
      } else if (session.scene === 'team') {
        this.fetchTeamInfo(session.to)
        // if (!this.$store.state.imTeams[session.to]) {
        //   this.fetchTeamInfo(session.to)
        // }
      }
    },
    fetchUserInfo (account) {
      this.$store.dispatch('fetchUserInfo', account)
    },
    fetchTeamInfo (teamId) {
      this.$store.dispatch('fetchTeamInfo', teamId)
    },
    onroamingmsgs (obj) {
      console.log('漫游消息', obj)
    },
    onofflinemsgs (obj) {
      console.log('离线消息', obj)
    },
    onMsg (msg) {
      console.log('收到消息', msg.scene, msg.type, msg)
      switch (msg.type) {
        case 'text':
          this.onMsgText(msg)
          break
        case 'image':
          this.onMsgText(msg)
          break
        case 'file':
          this.onMsgText(msg)
          break
        case 'audio':
          this.onMsgText(msg)
          break
        case 'video':
          this.onMsgText(msg)
          break
        case 'custom':
          /**
           * 收到自定义消息，用户d根据消息内容处理
           */
          this.onMsgText(msg)
          break
        case 'notification':
          /**
           * 收到群通知消息，用户根据群通知的消息进行进一步处理
           */
          this.onMsgText(msg)
          this.notification(msg)
          break
        // 其它case
        default:
          break
      }
    },
    onMsgText (msg) {
      console.log('onMsgText', msg)
      console.log(this.imActiveAccount)
      this.addMsgToMsgArr(msg)
      // 多端登录下如果发送方是本身 并且不处于当前会话状态下则 return
      if (msg.from === this.imAccount.im_accid && (!this.imActiveAccount.to || msg.to !== this.imActiveAccount.to) ) return
      // 多端登录下如果发送方是本身，并且已经处于当前会话状态下直接将窗口滚动到最底部
      if (msg.from === this.imAccount.im_accid && msg.to === this.imActiveAccount.to && msg.scene === this.imActiveAccount.scene) {
        this.$store.commit('imMsgListToBottomMutation', true)
        return
      }
      // 发送方非本身
      if (this.imActiveAccount && msg.scene === 'p2p' && this.imActiveAccount.to === msg.from && msg.scene === this.imActiveAccount.scene && this.imVisible && this.imLeftActiveName === 'chat') {
        // 如果会话窗口处于打开状态，并且已经处于当前会话状态下，则发送已读回执，并通知其他端已登录的相同账号更新消息状态，滚动条直接到底部
        this.msgReceiptSend(msg)
        this.$store.commit('imMsgListToBottomMutation', true)
      } else if (this.imActiveAccount && msg.scene === 'team' && this.imActiveAccount.to === msg.to && msg.scene === this.imActiveAccount.scene && this.imVisible && this.imLeftActiveName === 'chat') {
        this.$store.commit('imMsgListToBottomMutation', true)
      } else if (this.imVisible && this.imLeftActiveName !== 'chat') {
        // 如果不处于当前会话状态下，那么未读总数加1
        // this.addUnReadCount(1)
      } else {
        // 会话窗口未打开，那么发送消息提醒，未读总数加1
        this.showNotification(msg)
        // this.addUnReadCount(1)
      }
    },
    showNotification (msg) {
      let message = ''
      if (msg.type === 'text') {
        message = msg.text
      } else if (msg.type === 'image') {
        message = '[图片消息]'
      } else if (msg.type === 'file') {
        message = msg.file.name
      } else if (msg.type === 'audio') {
        message = '[音频]'
      } else if (msg.type === 'video') {
        message = '[视频]'
      } else if (msg.type === 'notification') {
        message = '[通知]'
      } else if (msg.type === 'custom') {
        message = '[自定义消息]'
      }
      let title = ''
      if (msg.scene === 'p2p') {
        title = msg.fromNick
      } else {
        title = this.$store.state.imTeams[msg.to].name
        message = msg.fromNick + '：' + message
      }
      if (this.$store.state.imActiveAccount.id && this.$store.state.imActiveAccount.id === msg.sessionId && this.imVisible) return
      const instance = this.$notify({
        title: title,
        message: message,
        onClick: () => this.handleNotificationClick(instance, msg.sessionId), // 传递实例
      });
      this.notificationInstances.push(instance)
    },
    handleNotificationClick (instance, sessionId) {
      console.log('this.$store.state.imSessionMap[sessionId]', this.$store.state.imSessionMap[sessionId])
      instance.close()
      // 从数组中移除已关闭的 Notification 实例
      this.notificationInstances = this.notificationInstances.filter(notif => notif !== instance)
      // 打开会话窗口并初获取会话数据
      if (!this.$store.state.imVisible) this.$store.dispatch('showImWindowStoreAction', true)
      if (this.imLeftActiveName !== 'chat') this.$store.commit('changeImLeftActiveNameStoreMutation', 'chat')
      this.$store.dispatch('changeImActiveAccountAction', this.$store.state.imSessionMap[sessionId])
      this.$store.dispatch('imActiveChange', { session: this.$store.state.imSessionMap[sessionId], scene: this.$store.state.imActiveAccount.scene, to: this.$store.state.imActiveAccount.to, messageListScrollTot: 'bottom', imAccId: this.$store.state.imAccount.im_accid })
      this.$store.commit('imMsgListToBottomMutation', true)
      console.log('handleNotificationClick', this.$store.state.imUnreadCount)
    },
    onMsgReceipts (data) {
      for (let i = 0; i < data.length; i++) {
        let session = this.$store.state.imSessionMap[data[i].sessionId]
        this.markMsgReceived(session);
      }
      console.log('已读回执', this.$store.state.imSessionMap)
    },
    onsysmsgunread (obj) {
      console.log('收到系统通知未读数', obj);
    },
    onupdatesysmsgunread (obj) {
      console.log('系统通知未读数更新了', obj);
    },
    oncustomsysmsg (sysMsg) {
      console.log('收到自定义系统通知', sysMsg)
      if (sysMsg.content && sysMsg.content) {
        let content = JSON.parse(sysMsg.content)
        if (content.type === 'sycMsgReceiptsNotify') {
          this.updateSycMsgReceipts(content.sessionId, content.from)
        }
      }
    },
    updateSycMsgReceipts (sessionId, connectionId) {
      console.log('sycMsgReceiptsNotify', sessionId)
      console.log('imActiveAccount', this.imActiveAccount)
      console.log('imSessions', this.$store.state.imSessions)
      console.log('this.$store.state.imSessionMap', this.$store.state.imSessionMap)
      console.log('imSessionMap', this.$store.state.imSessionMap[sessionId])
      // 如果是 当前 connectionId 发送的通知 则return
      if (this.imConnectionId === connectionId) return
      // 如果当前已处于对应会话状态，并且不是当前 connectionId 发送的通知 则只需将未读总数减1
      if (this.imActiveAccount.id && this.imActiveAccount.id === sessionId && this.imVisible && this.imLeftActiveName === 'chat') {
        console.log('this.$store.state.imUnreadCount', this.$store.state.imUnreadCount)
        // this.$store.dispatch('reduceImUnreadCountAction', 1)
        return
      }
      if (this.imActiveAccount.id && this.imActiveAccount.id === sessionId && (!this.imVisible || this.imLeftActiveName !== 'chat')) {
        // this.$store.dispatch('reduceImUnreadCountAction', 1)
        return
      }
      // 如果当前不处于对应会话状态，并且 不是 当前 connectionId 发送的通知
      if (this.imConnectionId !== connectionId) {
        if (this.imLeftActiveName !== 'chat') this.$store.commit('changeImLeftActiveNameStoreMutation', 'chat')
        this.$store.dispatch('changeImActiveAccountAction', this.$store.state.imSessionMap[sessionId])
        this.$store.dispatch('imActiveChange', { session: this.$store.state.imSessionMap[sessionId], scene: this.$store.state.imActiveAccount.scene, to: this.$store.state.imActiveAccount.to, messageListScrollTot: 'bottom', imAccId: this.$store.state.imAccount.im_accid })
        this.$store.commit('imMsgListToBottomMutation', true)
        console.log('sycMsgReceiptsNotify 已同步')
      }
    },
    // 群
    onteams (teams) {
      console.log('teams', teams)
      for (const team of teams) {
        this.$store.commit('addImTeamMutation', team)
        this.$store.commit('addImTeamArrMutation', team)
      }
    },
    notification (msg) {
      if (msg.attach && msg.attach.type === 'addTeamMembers' && msg.attach.team.owner === this.imAccount.im_accid) {
        const session = this.$store.state.imSessionMap[msg.sessionId]
        this.$store.dispatch('changeImActiveAccountAction', session)
        this.imActiveChange({ session: session, scene: 'team', to: this.imActiveAccount.to, messageListScrollTot: 'bottom', imAccId: this.imAccount.im_accid })
      }
    },
    onCreateTeam (data) {
      console.log('我创建了群：', data)
    },
    shouldCountNotifyUnread (msg) {
      return msg && msg.attach && msg.attach.type !== "removeTeamMembers"
    },
    onRemoveTeamMembers (data) {
      console.log('onRemoveTeamMembers', data)
    },
    // 初始化同步完成
    onsyncdone () {
      for (let sessionId in this.$store.state.imSessionMap) {
        const session = this.$store.state.imSessionMap[sessionId]
        if (session.scene === 'p2p') {
          this.markMsgReceived(session)
        }
      }
    }
  },
  mounted () {
    this.getImAccount()
  }
}
</script>

<style lang="stylus" scoped>
.im-right {
  display: flex;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ImRight.vue